<template>
    <div>
        <v-container grid-list-xl fluid fill-height>
            <v-layout row wrap :justify-center="$bp.xs">
                <!-- <v-flex style="flex-grow:0; flex-basis: 0;">
                    <v-card tile height="200" width="250" class="text-xs-center elevation-10 clickable" @mouseup.left="showAddress()">
                        <v-flex class="pa-0">
                            <v-icon color="primary" style="margin-top:82px;" size="36">add</v-icon>
                        </v-flex>
                    </v-card>
                </v-flex> -->
                <v-flex v-for="(address, index) in addresses" :key="index" style="flex-grow: 0; flex-basis: 0">
                    <v-card height="125" width="175" class="subheading text-xs-center py-2 elevation-2 clickable" @mouseup.left="showAddress(address)">
                        <!-- <v-icon size="36" fill-height color="primary">location_on</v-icon> -->
                        <v-flex class="pa-1 overflow-address">{{ address.address1 }}</v-flex>
                        <v-flex class="pb-0 px-1 pt-1 fs-14">{{ address.city }}, {{ address.state }} {{ address.zip_code }}</v-flex>
                        <v-flex class="pt-0 px-1 pb-1 fs-14">{{ $t(`lang.${address.address_type}`) }}</v-flex>
                        <v-chip color="primary" class="mb-2 mt-0 pa-1 body-2 white--text" small v-if="address.prime == true" disabled>{{
                            $t("lang.primary_caps")
                        }}</v-chip>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <bc-address-dialog
            ref="addressDialog"
            :getFunction="getFunction"
            :object_id="current_user.people_id"
            object_ref="people"
            :total_items="addresses ? addresses : null"
        ></bc-address-dialog>
    </div>
</template>

<script>
export default {
    props: ["addresses", "getFunction"],
    methods: {
        showAddress(address = null) {
            this.$refs.addressDialog.showAddress(address);
        },
    },
};
</script>
